export default __webpack_public_path__ + "images/a088658a15415bda0bc6ba9842902483-selfie.png";